<section class="section section--promise pdf-page-wrapper">
  <div class="container">
    <h2 [innerText]="'Our promise to you.' | translate" class="secondary-heading secondary-heading--white"></h2>
    <h3 [innerText]="'Everything you do helps us make a positive impact.' | translate"
    class="tertiary-heading tertiary-heading--dark-blue"></h3>

    <div class="tiles">
      @for (item of companyPromises; track trackByFn(i, item); let i = $index) {
        <div class="tiles__item">
          <div class="hide-for-print">
            <div class="tiles__icon tiles__icon--{{i + 1}}">
              <img [src]="'https://storage.googleapis.com/archipelago-assets/total-impact-statement/icons/' + item.icon"
                alt="">
            </div>
            <h3 [innerText]="item.title"></h3>
            @if (!isPrintPDFRoute) {
              <p [innerText]="item.shortDescriptionDigital"></p>
            }
            @if (isPrintPDFRoute) {
              <p [innerText]="item.longDescriptionPrint"></p>
            }
          </div>
          <button
            (click)="openModal(template)"
            [attr.aria-label]="'Learn more about ' + item.title"
            class="btn btn-primary"><span [innerText]="'Learn more' | translate"></span>
          </button>
          <div class="print-only">
            <h2 [innerText]="item.title" class="print-only__secondary-heading"></h2>
            <h3 [innerText]="item.shortDescriptionDigital"
            class="tertiary-heading tertiary-heading--modal"></h3>
            @if (item.longDescriptionDigital) {
              <p [innerText]="item.longDescriptionDigital"></p>
            }
          </div>
          <ng-template #template>
            <div class="modal-header">
              <h2 [innerText]="item.title + '.'"
              class="secondary-heading secondary-heading--modal pull-left"></h2>
            </div>
            <div class="modal-body">
              <h3 [innerText]="item.shortDescriptionDigital"
              class="tertiary-heading tertiary-heading--modal"></h3>
              @if (item.longDescriptionDigital) {
                <p [innerText]="item.longDescriptionDigital"></p>
              }
            </div>
            <button (click)="modalRef.hide()" aria-label="Close" class="modal__close pull-right" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </ng-template>
        </div>
      }
    </div>
  </div>
</section>


